var deserializeItems;

deserializeItems = function(pathList, outline, options) {
  var each, filenames, i, item, items, len;
  filenames = pathList.split('\n');
  items = [];
  for (i = 0, len = filenames.length; i < len; i++) {
    each = filenames[i];
    item = outline.createItem();
    item.bodyString = each.trim().replace(/[ ]/g, '\\ ');
    items.push(item);
  }
  return items;
};

module.exports = {
  deserializeItems: deserializeItems
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/paths.js
 ** module id = 202
 ** module chunks = 0
 **/